import { render } from "./BaseSelectMultiple.vue?vue&type=template&id=285f9adc&ts=true"
import script from "./BaseSelectMultiple.vue?vue&type=script&lang=ts"
export * from "./BaseSelectMultiple.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__